import React from "react";

export default function PlantVisit() {
  return (
    <div className="steel-page">
      <div className="steel-container">
        <div className="steel-card">
          <div className="steel-body">
            {/* Heading */}
            <div className="steel-header">
              <h2>
                Forging Policy, Technology and Progress – Together for a
                Stronger, Sustainable, Resilient Atmanirbhar Bharat
              </h2>
              <p className="steel-date">
                23 October 2025 • Moira Steel, Indore
              </p>
            </div>

            {/* Highlight */}
            <div className="steel-highlight">
              <p>
                Historic Initiative by India’s Secondary Steel Manufacturing
                Industry
              </p>
            </div>

            {/* Content */}
            <div className="steel-content">
              <p>
                The visit to Moira Steel, Indore, on 23 October 2025, was
                organized under the leadership of AIIFA President, Shri Yogesh
                Mandhani ji, and accompanied by Shri Kamal Agarwal, Hon. General
                Secretary, AIIFA, and Shri Mohit Kapoor, Advisor, AIIFA. It
                marked a significant step in strengthening cooperation between
                the Government and India’s Secondary Steel Industry.
              </p>

              <p>
                The visit of Shri Sandeep Poundrik, IAS, Hon’ble Steel
                Secretary, Government of India, along with Shri Sarthi, Deputy
                Secretary, Ministry of Steel, and Shri Paramjeet Singh,
                Director, NISST, to Moira Steel, Indore, on 23 October 2025,
                marks a defining milestone in the ongoing transformation of
                India’s Secondary Steel Manufacturing Industry.
              </p>

              <p>
                The delegation was warmly welcomed by Shri Pawan Singhania Ji,
                Executive Vice Chairman, Moira Steel, who extended a gracious
                reception and led an insightful presentation on the company’s
                journey and achievements.
              </p>

              <p>
                Shri Singhania Ji also showcased a video presentation of the
                plant, providing an immersive overview of Moira Steel’s
                state-of-the-art operations and sustainability initiatives.
              </p>

              <p>
                During the visit, AIIFA also presented its success video —
                “Steel Mahakumbh – Steelex 2025 Expo: Video Glimpses,”
                highlighting the scale, participation, and impact of the
                landmark event that celebrated the unity and progress of India’s
                Secondary Steel Industry.
              </p>

              <p>
                Management and senior staff of Moira Steel led by Executive Vice
                Chairman Shri Pawan Singhania, MD Shri Avinash Todi, Shri Amit
                Kishanpuriya, Shri Sandeep Jain and Shri Ashish Jalan took the
                delegation for factory tour and explained in detail the
                compliance protocol of operations.
              </p>

              <p>
                The detailed presentations by the Moira Steel management, led by
                Shri Pawan Singhania Ji and his senior leadership team,
                highlighted the industry’s strong adherence to compliance,
                quality, and sustainability standards — reflecting the evolving
                maturity and technological advancement of the secondary steel
                segment.
              </p>
            </div>

            {/* Section */}
            <h3 className="steel-section-title">Strategic Action Framework</h3>

            <div className="steel-content">
              <p>
                Building on the success of this engagement, the following
                game-changing strategic actions are now being advanced to
                strengthen the sector’s alignment with national priorities and
                Atmanirbhar Bharat’s industrial vision:
              </p>

              <p>
                <strong>1. Policy Coordination and Advocacy:</strong> Establish
                a structured coordination mechanism with the Ministry of Steel
                and related departments to pursue ongoing reforms on GST
                rationalization. A detailed representation on the proposed GST
                amendment has been submitted and is attached as an annexure for
                reference.
              </p>

              <p>
                <strong>2. Sustainability and Green Transition:</strong>{" "}
                Initiate a sector-wide Green Steel Mission under AIIFA to
                position the secondary steel industry as a key enabler of
                India’s low-carbon, circular economy, focusing on resource
                optimization, carbon reduction, and renewable integration.
              </p>

              <p>
                <strong>
                  3. Technology Upgradation and Research Collaboration:
                </strong>{" "}
                Partner with NISST, leading metallurgical research institutions,
                and other renowned renewable energy and manufacturing excellence
                solution providers to identify and deploy innovation-led
                technologies that enhance energy efficiency, product quality,
                and process reliability.
              </p>

              <p>
                <strong>4. “SteelTech Workshop” Series at the Ministry:</strong>{" "}
                Conduct the next SteelTech Workshop to showcase best practices
                in specialty steel manufacturing, process optimization, and
                quality improvement — featuring participation from eminent
                metallurgists and technology experts.
              </p>

              <p>
                <strong>5. Industry Outreach and Image Repositioning:</strong>{" "}
                Implement a coordinated communication strategy to reshape the
                perception of the secondary steel industry from an
                energy-intensive sector to one that is modern, efficient, and
                sustainable — aligned with the vision of a Resilient Atmanirbhar
                Bharat.
              </p>
            </div>

            {/* Closing */}
            <div className="steel-footer">
              <p>
                These steps signify a unified resolve to position the secondary
                steel industry at the forefront of India’s industrial growth and
                sustainability agenda. Collective participation, consistent
                engagement with policymakers, and a focus on technology-led
                transformation will ensure that the sector remains a cornerstone
                of India’s self-reliant future.
              </p>

              <p>
                <strong>With regards,</strong>
                <br />
                Kamal Agarwal
                <br />
                Hon. Secretary, General AIIFA
              </p>

              <p>
                <strong>Annexures</strong>
                <br />
                Annexure – I: Representation on GST Amendment
                <br />
                Annexure – II: Moira Steel Plant Visit Photographs – Glimpses
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
